import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db, analytics } from "../firebase/firebase-config";
import { logEvent } from "firebase/analytics";
import {
  TextField,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
  Box,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { BiSubdirectoryRight } from "react-icons/bi";

const Redirect = () => {
  const { code: routeCode } = useParams();
  const [code, setCode] = useState(routeCode || "");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  React.useEffect(() => {
    logEvent(analytics, "screen_view", { screen_name: "redirects" });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!code) return;
    setLoading(true);
    setError("");
    try {
      window.location.href = `https://back-house.com/r/${code}`;
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={{ minHeight: "100vh", padding: "1rem" }}
    >
      <Grid item xs={12} sm={8} md={6}>
        <Card sx={{ borderRadius: "36px", backgroundColor: "#f5f5f5" }}>
          <CardContent>
            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                type="text"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="Enter code"
                required
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleSubmit} edge="end">
                        <BiSubdirectoryRight size={36} />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  ".MuiInputBase-input": {
                    fontSize: { xs: "0.99rem" },
                    fontFamily: "Nunito",
                    fontWeight: 600,
                    letterSpacing: "0.045rem",
                    color: "#202426",
                    textTransform: "uppercase",
                  },
                  "& .MuiOutlinedInput-root": {
                    marginTop: "1.08rem",
                    height: "63px",
                    borderRadius: "18px",
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#93A683",
                    },
                  },
                }}
              />
            </form>
            {loading && <Typography variant="body2">Loading...</Typography>}
            {error && (
              <Typography variant="body2" color="error">
                {error}
              </Typography>
            )}
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default Redirect;
